import entity from '../../../models/mlm/categories'

export default [
  {
    path: '/categories',
    meta: {
      entity,
      requiresPermissionTo: 'categories',
      crud: 'list'
    },
    component: () =>
      import(
        /* webpackChunkName: 'banners' */ '@/views/dynamic/DynamicIndex.vue'
      )
  },
  {
    path: '/categories/new',
    meta: {
      entity,
      requiresPermissionTo: 'categories',
      crud: 'form'
    },
    component: () =>
      import(
        /* webpackChunkName: 'banners' */ '@/views/dynamic/DynamicIndex.vue'
      )
  },
  {
    path: '/categories/:id',
    meta: {
      entity,
      requiresPermissionTo: 'categories',
      crud: 'form'
    },
    component: () =>
      import(
        /* webpackChunkName: 'banners' */ '@/views/dynamic/DynamicIndex.vue'
      )
  }
]
